import Hero from './Hero';
import Features from './Features';
import CTA from './CTA';
import Members from './Members';
import Footer from 'components/Footer';

export default function App() {
	return (
		<>
			<Hero />
			<Features />
			<CTA />
			<Members />
			<Footer />
		</>
	);
}
